import { useState, useRef, useCallback } from 'react';

export function useDraggableFab(onTap) {
  const fabRef = useRef(null);
  const dragState = useRef({ isDragging: false, startX: 0, startY: 0, startRight: 32, startBottom: 32, hasMoved: false });
  const [fabPos, setFabPos] = useState({ right: 32, bottom: 32 });

  const handlePointerDown = useCallback((e) => {
    e.preventDefault();
    const ds = dragState.current;
    ds.isDragging = true;
    ds.hasMoved = false;
    ds.startX = e.clientX;
    ds.startY = e.clientY;
    ds.startRight = fabPos.right;
    ds.startBottom = fabPos.bottom;
    fabRef.current?.setPointerCapture(e.pointerId);
  }, [fabPos]);

  const handlePointerMove = useCallback((e) => {
    const ds = dragState.current;
    if (!ds.isDragging) return;
    const dx = e.clientX - ds.startX;
    const dy = e.clientY - ds.startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) ds.hasMoved = true;
    const newRight = Math.max(8, Math.min(window.innerWidth - 72, ds.startRight - dx));
    const newBottom = Math.max(8, Math.min(window.innerHeight - 72, ds.startBottom - dy));
    setFabPos({ right: newRight, bottom: newBottom });
  }, []);

  const handlePointerUp = useCallback((e) => {
    const ds = dragState.current;
    ds.isDragging = false;
    fabRef.current?.releasePointerCapture(e.pointerId);
    if (!ds.hasMoved) onTap();
  }, [onTap]);

  return { fabRef, fabPos, handlePointerDown, handlePointerMove, handlePointerUp };
}
